import { Skeleton } from '@deltasierra/react-components-core';
import { ShowOn } from '@deltasierra/react-layouts';
import { useCallback } from 'react';
import { AssetLibraryGalleryGridItemDesktop } from './AssetLibraryGalleryGridItemDesktop';
import { AssetLibraryGalleryGridItemMissingThumbnail } from './AssetLibraryGalleryGridItemMissingThumbnail';
import { AssetLibraryGalleryGridItemMobile } from './AssetLibraryGalleryGridItemMobile';
import { AssetType } from './constants';
import { type AssetLibraryGalleryGridItemProps } from './types';
import { shouldPollForMissingThumbnail } from './utils';

export const AssetLibraryGalleryGridItem = ({
    asset,
    isLoading,
    isSelected,
    onClickAsset,
    onClickAssetPreview,
    onClickDownload,
    onClickOpenActions,
    onClickSelectItem,
    onDoubleClickFolder,
    t,
}: AssetLibraryGalleryGridItemProps): JSX.Element => {
    const isPollingForMissingThumbnail = isLoading ? false : shouldPollForMissingThumbnail(asset);

    const { height, width } = asset.dimensions;

    const onOpenItem = useCallback(() => {
        if (asset.type === AssetType.Folder) {
            onDoubleClickFolder?.(asset.id);
        } else {
            onClickAssetPreview?.(asset);
        }
    }, [asset, onDoubleClickFolder, onClickAssetPreview]);

    if (isLoading) {
        return <Skeleton height={height} variant="rounded" width={width} />;
    }

    const gridItemProps = {
        asset,
        isSelected,
        onClickAsset,
        onClickAssetPreview,
        onClickDownload,
        onClickOpenActions,
        onClickSelectItem,
        onDoubleClickFolder,
        onOpenItem,
        t,
    };

    return (
        <>
            {isPollingForMissingThumbnail && <AssetLibraryGalleryGridItemMissingThumbnail asset={asset} />}
            <ShowOn mobile>{() => <AssetLibraryGalleryGridItemMobile {...gridItemProps} />}</ShowOn>
            <ShowOn desktop>{() => <AssetLibraryGalleryGridItemDesktop {...gridItemProps} />}</ShowOn>
        </>
    );
};

AssetLibraryGalleryGridItem.displayName = 'AssetLibraryGalleryGridItem';
